// where undefined === no limit to query length
export var MAX_SEARCH_QUERY_LENGTH = undefined;
//# sourceMappingURL=constants.js.map